const state = {
  campaignId: null,
  allCampaigns: false,
  statSelected: null,
};

const getters = {
  currentCampaignName(state, _getters, _rootState, rootGetters) {
    const NO_SELECTION = 'N/A';

    if (state.campaignId !== null) {
      const campaign = rootGetters['models/campaign/getCampaignById'](state.campaignId);

      return campaign ? campaign.name : NO_SELECTION;
    }

    if (state.allCampaigns) {
      return null;
    }

    return NO_SELECTION;
  },
};

const actions = {
  setSelectedStat(context, value) {
    context.commit('SET_SELECTED_STAT', value);
  },

  setCampaign(context, id) {
    context.commit('SET_CAMPAIGN', id);
  },

  showAllCampaigns(context, value) {
    if (value) {
      context.dispatch('SET_CAMPAIGN', null);
    }
    context.commit('SHOW_ALL_CAMPAIGNS', value);
  },
};

const mutations = {
  SET_SELECTED_STAT(context, value) {
    state.statSelected = value;
  },

  SET_CAMPAIGN(state, campaignId) {
    state.campaignId = campaignId;
  },

  SHOW_ALL_CAMPAIGNS(state, value) {
    state.allCampaigns = Boolean(value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
